var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-svg": "true",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8.711 6.593",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M2.354,6.38L0.212,4.23c-0.2844-0.2828-0.2858-0.7426-0.003-1.027S0.9516,2.9172,1.236,3.2l1.631,1.638 l4.608-4.625C7.7589-0.07,8.2185-0.0694,8.5015,0.2145S8.7839,0.958,8.5,1.241L3.379,6.38 C3.0979,6.6628,2.6407,6.6641,2.3579,6.3829C2.357,6.382,2.356,6.381,2.355,6.38H2.354z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M2.8662,6.5933c-0.1854,0-0.3707-0.071-0.5119-0.213L0.2125,4.2299c-0.2833-0.284-0.2833-0.7442,0-1.0281 C0.3537,3.0601,0.539,2.9893,0.7243,2.9893s0.3706,0.0708,0.5118,0.2125l1.6306,1.6367l4.608-4.6254 C7.6161,0.071,7.8014,0,7.9866,0c0.1853,0,0.3706,0.071,0.5118,0.213c0.2833,0.284,0.2833,0.7441,0,1.0281L3.3786,6.3803 C3.237,6.5223,3.0516,6.5933,2.8662,6.5933z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.fd8cc28f.svg";
export { ForwardRef as ReactComponent };